import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import * as userApis from "apis/users";

import "../../assets/css/grid.scss";
import "../../assets/css/style.scss";
import logo from '../../assets/images/logo.png';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    if (newPassword.length < 8) {
      return "Password must be at least 8 characters long.";
    }
    if (newPassword !== confirmPassword) {
      return "Passwords do not match.";
    }
    if (!token) {
      return "Invalid or missing token.";
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      setLoading(true);
      await userApis.resetPassword({ token, newPassword });
      setSuccess("Password has been reset successfully.");
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <div className="col-lg-100 col-md-100 col-sm-100 full-height pt-40">
        <div className="login pt-40">
          <div className="logo">
            <img src={logo} alt="logo" />
          </div>
          {success && (
              <>
              <div className="success">
              <h1>{success}</h1>
              <p>
               <Link to="/login">Click here to login</Link>
              </p>
            </div>
             
           </>

              
            )}
             {!success && (
               <>
          <div className="login-title">
            <h1>Set a new password</h1>
            <h6>Must be at least 8 characters.</h6>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
          

           
             
                <div className="login-input">
                  <label htmlFor="newPassword">New Password</label>
                  <input
                    type="password"
                    id="newPassword"
                    placeholder="Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="login-input">
                  <label htmlFor="confirmPassword">Confirm Password</label>
                  <input
                    type="password"
                    id="confirmPassword"
                    placeholder="Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>

                {error && (
                  <div className="errors">
                    <h1>{error}</h1>
                  </div>
                )}

                <div className="login-input">
                  <button type="submit" disabled={loading}>
                    {loading ? "Resetting..." : "Reset Password"}
                  </button>
                </div>
              
           
          </form>
          </>)}
        </div>

      </div>
    </div>
  );
}

export default ResetPassword;
